import { createIcon } from '../icon'
import AtIcon from '../svg/AtIcon'

export const AtIconDefault = createIcon(AtIcon)
